import { createSlice } from "@reduxjs/toolkit";
import LogoDefault from "assets/images/logo.png";
import { ApplicationRootState } from "types";
import { RetriveStateType } from "types/retrieve";

import { extraReducers } from "./retrieve.extraReducers";

export const initialState: RetriveStateType = {
  isAnnouncementLoading: false,
  announcements: null,
  isBannerLoading: false,
  banners: null,
  totalAnnouncements: 0,
  isLoading: false,
  logo: LogoDefault,
  wager: {
    data: [],
    totalCount: 0,
    totalPages: 0,
  },
};
const retrieveSlice = createSlice({
  name: "retrieve",
  initialState,
  reducers: {
    //
  },
  extraReducers,
});

export const selectAnnouncements = (state: ApplicationRootState) =>
  state.retrieve.announcements;
export const selectIsAnnouncementLoading = (state: ApplicationRootState) =>
  state.retrieve.isAnnouncementLoading;
export const selectBanners = (state: ApplicationRootState) =>
  state.retrieve.banners;
export const selectIsBannerLoading = (state: ApplicationRootState) =>
  state.retrieve.isBannerLoading;
export const selectTotalAnnouncements = (state: ApplicationRootState) =>
  state.retrieve.totalAnnouncements;
export const selectLogo = (state: ApplicationRootState) => state.retrieve.logo;

export const selectIsLoading = (state: ApplicationRootState) =>
  state.retrieve.isLoading;
export const selectWager = (state: ApplicationRootState) =>
  state.retrieve.wager;

export default retrieveSlice.reducer;
